import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { VehicleService } from 'src/app/shared/sdk';

@Component({
  selector: 'app-vehicle-service-details-tabs',
  templateUrl: './vehicle-service-details-tabs.component.html',
  styleUrls: ['./vehicle-service-details-tabs.component.scss'],
})
export class VehicleServiceDetailsTabsComponent implements OnInit {
  selectedIndex = 0;
  tabs: any[] = [
    { title: 'Requests', template: 'requests' },
    { title: 'Service States', template: 'service-states' },
    { title: 'Schedules', template: 'schedules' },
    { title: 'Invoices', template: 'invoices' },
    { title: 'Fleet Manager Comments', template: 'fleet-manager-comments' },
  ];

  @Input() vehicleService: VehicleService;

  constructor() {}

  ngOnInit() {}

  repaint() {}
}
